export const HOME_PAGE_TABS = [
  {
    title: 'DIRECT_TRANSACTIONS',
    value: 0,
    route: 'transaction'
  },
  {
    title: 'MULTI_TIER_TRANSACTIONS',
    value: 1,
    route: 'transaction/multi-tier'
  },
  {
    title: 'PRICE',
    value: 2,
    route: 'price'
  }
];
